import Vue from "vue"
import axios from "../plugins/axios"
import moment from "moment-timezone"

Vue.prototype.$http = axios
Vue.prototype.$moment = moment

const getDefaultState = () => {
    return {
        vtc: {
            providers_count: 0,
            active: true,
            treated_diffs_count: 0,
            waiting_diffs_count: 0,
        },
        currentStep: 1,
        addProStep: 1,
        selectedCategories: [],
        selectedCommunes: [],
        selectedTourismSectors: [],
        selectedTags: [],
        selectedApidaeSelection: null,
        providersToAdd: [],
        providersReadyToImport: [],
        emailsValid: [],
        emailsWrong: [],
        noEmails: [],
        filteredProviders: [],
        alreadyInVtc: [],
        notAlreadyInVtc: [],
        providerWithoutGoogleSource: null,
        selectGoogleSourceModal: false,
        providers: [],
        selectedProviders: [],
        vtcMaxProvidersCount: 10,
        selectedProvidersFromVtcList: [],
        treatedVtcDiffs: [],
        treatedVtcDiffsSearchName: null,
        waitingDiffSearchName: null,
        treatedVtcDiffSortOrder: 'desc',
        waitingVtcDiffSortOrder: 'desc',
    }
}

const vtc = {
    namespaced: true,
    state: getDefaultState(),
    getters: {},
    mutations: {
        setVtc(state, data) {
            state.vtc = data
        },
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setAddProStep(state, value) {
          state.addProStep = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedTourismSectors(state, value) {
            state.selectedTourismSectors = value
        },
        setSelectedApidaeSelection(state, value) {
            state.selectedApidaeSelection = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setProvidersToAdd(state, value) {
            state.providersToAdd = value
        },
        setEmailsValid(state, value) {
            state.emailsValid = value
        },
        setEmailsWrong(state, value) {
            state.emailsWrong = value
        },
        setNoEmails(state, value) {
            state.noEmails = value
        },
        setProvidersReadyToImport(state, value) {
            state.providersReadyToImport = value
        },
        setProviderToAddByIndex(state, [index, value]) {
            state.providersToAdd[index] = value
        },
        setFilteredProviders(state, value) {
            state.filteredProviders = value
        },
        setAlreadyInVtc(state, value) {
          state.alreadyInVtc = value
        },
        setNotAlreadyInVtc(state, value) {
          state.notAlreadyInVtc = value
        },
        setProviderWithoutGoogleSource(state, value) {
          state.providerWithoutGoogleSource = value
        },
        setSelectGoogleSourceModal(state, value) {
          state.selectGoogleSourceModal = value
        },
        setProviders(state, value) {
          state.providers = value
        },
        setVtcMaxProvidersCount(state, value) {
          state.vtcMaxProvidersCount = value
        },
        setSelectedProviders(state, value) {
          state.selectedProviders = value
        },
        setSelectedProvidersFromVtcList(state, value) {
            state.selectedProvidersFromVtcList.splice(0, state.selectedProvidersFromVtcList.length, ...value)
        },
        setTreatedVtcDiffs(state, value) {
          state.treatedVtcDiffs = value
        },
        setTreatedVtcDiffsSearchName(state, value) {
          state.treatedVtcDiffsSearchName = value
        },
        setWaitingDiffSearchName(state, value) {
          state.waitingDiffSearchName = value
        },
        setTreatedVtcDiffSortOrder(state, value) {
          state.treatedVtcDiffSortOrder = value
        },
        setWaitingVtcDiffSortOrder(state, value) {
          state.waitingVtcDiffSortOrder = value
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default vtc